<template>
  <div class="table-header-basic">
    <div v-if="$listeners['searchDate']" class="date">
      <span>日期：</span>
      <b-form-input
        :value="$store.getters.startedAt"
        @input="$store.commit('startedAt', $event)"
        type="date"
      ></b-form-input>
      <span class="to">～</span>
      <b-form-input
        :value="$store.getters.endedAt"
        @input="$store.commit('endedAt', $event)"
        type="date"
      ></b-form-input>
      <b-button variant="primary" @click="updateDate">搜尋 </b-button>
    </div>
    <div v-if="$listeners['searchKeyWord']" class="key-word">
      <b-input
        :value="$store.getters.keyWord"
        @input="updateKeyWord"
        placeholder="請輸入關鍵字搜尋"
      ></b-input>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    updateKeyWord(kw) {
      this.$store.commit("keyWord", kw);
      this.$store.commit("page", 1);
      this.$emit("searchKeyWord");
    },
    updateDate() {
      this.$store.commit("page", 1);
      this.$emit("searchDate");
    }
  }
};
</script>

<style lang="scss" scoped>
.table-header-basic {
  display: flex;
  align-items: center;
  margin-bottom: 0.8rem;
}

.table-header-basic {
  .date {
    display: flex;
    align-items: center;
    .to {
      margin: 0 0.25rem;
    }
    input {
      width: 12rem;
    }
    button {
      margin-left: 0.25rem;
    }
  }
}

.table-header-basic {
  .key-word {
    margin-left: 10rem;
    width: 20rem;
  }
}
</style>
